import { axiosInstance } from '@/Api/axiosV2Config';
import type { VehicleSearchResponse } from '../types/vehicle.types';

/**
 * API client pour la recherche de véhicules
 */
export const vehicleApi = {
  /**
   * Recherche un véhicule via SIVIN (immatriculation ou VIN)
   */
  searchVehicle: async (
    searchValue: string,
    type: 1 | 2,
    societyId?: string,
  ): Promise<VehicleSearchResponse> => {
    const { data } = await axiosInstance.post<VehicleSearchResponse>(
      '/pro-v2/vehicles/search-sivin',
      {
        searchValue,
        type,
        societyId,
      },
    );
    return data;
  },
};
